import React from "react";

function RemoveIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9625_17090)">
        <path
          d="M20.0078 5.40723C20.273 5.40723 20.5274 5.51258 20.7149 5.70012C20.9025 5.88766 21.0078 6.14201 21.0078 6.40723C21.0078 6.67244 20.9025 6.9268 20.7149 7.11433C20.5274 7.30187 20.273 7.40723 20.0078 7.40723H19.0078L19.0048 7.47823L18.0718 20.5492C18.0359 21.0538 17.8101 21.526 17.4399 21.8708C17.0697 22.2156 16.5827 22.4072 16.0768 22.4072H7.93781C7.43195 22.4072 6.94488 22.2156 6.5747 21.8708C6.20452 21.526 5.97873 21.0538 5.94281 20.5492L5.00981 7.47923C5.0083 7.45526 5.00763 7.43124 5.00781 7.40723H4.00781C3.7426 7.40723 3.48824 7.30187 3.30071 7.11433C3.11317 6.9268 3.00781 6.67244 3.00781 6.40723C3.00781 6.14201 3.11317 5.88766 3.30071 5.70012C3.48824 5.51258 3.7426 5.40723 4.00781 5.40723H20.0078ZM17.0048 7.40723H7.01081L7.93881 20.4072H16.0768L17.0048 7.40723ZM14.0078 2.40723C14.273 2.40723 14.5274 2.51258 14.7149 2.70012C14.9025 2.88766 15.0078 3.14201 15.0078 3.40723C15.0078 3.67244 14.9025 3.9268 14.7149 4.11433C14.5274 4.30187 14.273 4.40723 14.0078 4.40723H10.0078C9.7426 4.40723 9.48824 4.30187 9.30071 4.11433C9.11317 3.9268 9.00781 3.67244 9.00781 3.40723C9.00781 3.14201 9.11317 2.88766 9.30071 2.70012C9.48824 2.51258 9.7426 2.40723 10.0078 2.40723H14.0078Z"
          fill="#667085"
        />
      </g>
      <defs>
        <clipPath id="clip0_9625_17090">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.405273)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RemoveIcon;
